// The gate desk's route subtree, hung off the STAFF portal's root route so
// router.tsx stays the single wiring point. Parent-generic (<TParent>) so the
// module never names a portal's Register-typed paths — the portability law the
// four Law F1 migration passes established.
import { createRoute } from "@tanstack/solid-router";
import { lazyRoute } from "@erp/ui/route-kit";
import type { AnyRoute } from "@tanstack/solid-router";

export function makeGuardStaffRoutes<TParent extends AnyRoute>(rootRoute: TParent) {
  const verifyRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "gate/verify",
  }).lazy(lazyRoute(() => import("../screens/Verify.js")));

  return [verifyRoute];
}
